import { useQuery } from "@tanstack/react-query";
import { api } from "./api/endpoints";
import type { Me, Role } from "./api/models";
import { qk } from "./queries";

export type Action = "read" | "export" | "create" | "edit" | "move" | "archive" | "admin";

const ACTIONS: Record<Role, readonly Action[]> = {
  viewer: ["read", "export"],
  editor: ["read", "export", "create", "edit", "move", "archive"],
  admin: ["read", "export", "create", "edit", "move", "archive", "admin"],
};

/** Role-level check for showing controls (spec §6.2). The server applies the full can() incl. restricted spaces. */
export function can(me: Me | null, action: Action): boolean {
  return me !== null && ACTIONS[me.role].includes(action);
}

export function useMe(): Me | null {
  const { data } = useQuery({ queryKey: qk.me, queryFn: api.me, staleTime: Number.POSITIVE_INFINITY });
  return data ?? null;
}
